// 商品物料映射管理
const TenManageApi = {
	list:"/tenant/user/tenantlist",//租户管理-列表
	addresource:"/tenant/resource/addresource",//租户资源-授权资源
	find:"/tenant/resource/authortenantresource",//查找单个
}



export{
	TenManageApi
}
